// extracted by mini-css-extract-plugin
module.exports = {"leftContainer":"styles_leftContainer__ulcY2"};